import { Module } from 'vuex';
import Plant from '@/models/plant';
import { list as listPlants } from '@/api/plants';
import {
  PLANTS_FETCH_PENDING,
  PLANTS_FETCH_SUCCESS,
  PLANTS_FETCH_FAILURE
} from '../mutation-types';
import { RootState } from '../types';

interface PlantsState {
  plants: {
    loading: boolean;
    error: string | null;
    results: Array<Plant>;
  };
}
const plants: Module<PlantsState, RootState> = {
  namespaced: true,
  state: {
    plants: {
      loading: false,
      error: null,
      results: []
    }
  },
  getters: {
    getPlants: state => state.plants.results,
    getPlantById: state => (id: number) =>
      state.plants.results.find(x => x.id === id)
  },
  actions: {
    async fetchPlants({ commit }) {
      commit(PLANTS_FETCH_PENDING);
      try {
        const results = await listPlants();
        commit(PLANTS_FETCH_SUCCESS, results);
      } catch (e) {
        commit(PLANTS_FETCH_FAILURE, e);
      }
    }
  },
  mutations: {
    // Categories related mutations
    [PLANTS_FETCH_PENDING](state) {
      state.plants.loading = true;
      state.plants.results = [];
      state.plants.error = null;
    },
    [PLANTS_FETCH_SUCCESS](state, payload: Array<Plant>) {
      state.plants.loading = false;
      state.plants.results = payload; // TODO .data;
    },
    [PLANTS_FETCH_FAILURE](state, error) {
      state.plants.loading = false;
      state.plants.results = [];
      state.plants.error = error;
    }
  }
};

export default plants;
